import Mixpanel from '../../pocs/mixpanel';

const mixpanel = new Mixpanel();

export default mixpanel;
